import { useState, useEffect } from 'react'
import { Routes, Route, Link } from 'react-router-dom'
import Queue from './pages/Queue.jsx'
import CopyReview from './pages/CopyReview.jsx'
import DesignReview from './pages/DesignReview.jsx'

const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:3002'

function App() {
  const [pieces, setPieces] = useState([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    fetchPieces()
  }, [])

  const fetchPieces = async () => {
    try {
      const res = await fetch(`${API_URL}/api/content`)
      const data = await res.json()
      setPieces(data.pieces || [])
    } catch (e) {
      console.error('Failed to fetch:', e)
    } finally {
      setLoading(false)
    }
  }

  const getStatusBadge = (status) => {
    const styles = {
      'ingested': 'bg-gray-100 text-gray-600',
      'research_done': 'bg-blue-100 text-blue-600',
      'drafts_ready': 'bg-yellow-100 text-yellow-700',
      'copy_approved': 'bg-indigo-100 text-indigo-600',
      'designs_ready': 'bg-purple-100 text-purple-600',
      'design_approved': 'bg-pink-100 text-pink-600',
      'ready_to_post': 'bg-green-100 text-green-600',
      'overdue': 'bg-red-100 text-red-600',
    }
    return styles[status] || 'bg-gray-100 text-gray-600'
  }

  const formatStatus = (status) => {
    return status?.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase())
  }

  return (
    <div className="min-h-screen bg-gray-50">
      <header className="bg-white shadow-sm border-b">
        <div className="max-w-7xl mx-auto px-4 py-4">
          <div className="flex items-center justify-between">
            <Link to="/" className="text-xl font-bold text-brand-600">
              IncX Content Pipeline
            </Link>
            <nav className="flex gap-4">
              <Link to="/" className="text-gray-600 hover:text-brand-600">
                Queue
              </Link>
            </nav>
          </div>
        </div>
      </header>

      <main className="max-w-7xl mx-auto px-4 py-8">
        <Routes>
          <Route path="/" element={
            <Queue pieces={pieces} loading={loading} getStatusBadge={getStatusBadge} formatStatus={formatStatus} />
          } />
          <Route path="/review/:pieceId/copy" element={
            <CopyReview apiUrl={API_URL} getStatusBadge={getStatusBadge} formatStatus={formatStatus} />
          } />
          <Route path="/review/:pieceId/design" element={
            <DesignReview apiUrl={API_URL} getStatusBadge={getStatusBadge} formatStatus={formatStatus} />
          } />
        </Routes>
      </main>
    </div>
  )
}

export default App
